import { render, staticRenderFns } from "./CompareBoard.vue?vue&type=template&id=1855557b&scoped=true&"
import script from "./CompareBoard.vue?vue&type=script&lang=js&"
export * from "./CompareBoard.vue?vue&type=script&lang=js&"
import style0 from "./CompareBoard.vue?vue&type=style&index=0&id=1855557b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855557b",
  null
  
)

export default component.exports